var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgArrow(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_7_860)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 30,
    height: 30,
    rx: 15,
    fill: "#191919"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.2314 10.0468C11.2184 9.8674 11.2772 9.69016 11.3949 9.55408C11.5126 9.41801 11.6795 9.33422 11.8589 9.32116L18.9065 8.81027C18.9966 8.80156 19.0875 8.81095 19.1739 8.83789C19.2602 8.86483 19.3404 8.90877 19.4095 8.96712C19.4787 9.02548 19.5354 9.09708 19.5765 9.1777C19.6176 9.25833 19.6421 9.34635 19.6486 9.4366C19.6552 9.52684 19.6436 9.61749 19.6146 9.7032C19.5856 9.7889 19.5398 9.86795 19.4798 9.93567C19.4198 10.0034 19.3468 10.0584 19.2652 10.0976C19.1837 10.1367 19.0951 10.1591 19.0047 10.1635L11.9571 10.6744C11.7776 10.6873 11.6004 10.6285 11.4643 10.5108C11.3282 10.3932 11.2444 10.2263 11.2314 10.0468Z",
    fill: "#D6B893",
    fillOpacity: 0.63
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.8999 16.9831C20.7257 17.0282 20.5408 17.0023 20.3857 16.9111C20.2307 16.8199 20.1182 16.6708 20.0729 16.4967L18.2989 9.65689C18.2741 9.56987 18.2669 9.47878 18.2778 9.38896C18.2888 9.29914 18.3175 9.21241 18.3625 9.13387C18.4074 9.05533 18.4676 8.98657 18.5395 8.93164C18.6114 8.87671 18.6935 8.83671 18.7811 8.81399C18.8687 8.79128 18.9599 8.78632 19.0495 8.79939C19.139 8.81246 19.225 8.8433 19.3025 8.89011C19.3799 8.93691 19.4472 8.99873 19.5004 9.07192C19.5536 9.14512 19.5916 9.22821 19.6122 9.31632L21.3863 16.1561C21.4314 16.3303 21.4055 16.5152 21.3143 16.6703C21.2231 16.8253 21.074 16.9379 20.8999 16.9831Z",
    fill: "#D6B893",
    fillOpacity: 0.63
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.9557 9.48687C19.1019 9.59177 19.2004 9.75048 19.2297 9.92806C19.2589 10.1056 19.2164 10.2876 19.1115 10.4338L11.5959 20.9095C11.491 21.0558 11.3323 21.1543 11.1547 21.1836C10.9771 21.2128 10.7952 21.1703 10.6489 21.0653C10.5027 20.9604 10.4042 20.8017 10.3749 20.6242C10.3457 20.4466 10.3882 20.2647 10.4932 20.1184L18.0087 9.64266C18.1136 9.49644 18.2723 9.39787 18.4499 9.36865C18.6275 9.33943 18.8094 9.38196 18.9557 9.48687Z",
    fill: "#D6B893",
    fillOpacity: 0.63
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_7_860"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 30,
    height: 30,
    rx: 15,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrow);
export default __webpack_public_path__ + "static/media/arrow.d1b28d8d1c0ada52b4c0c4abb7ff3d1c.svg";
export { ForwardRef as ReactComponent };